// extracted by mini-css-extract-plugin
module.exports = {"base":"src-TaskWindowContent-base-d12a2176","scroll":"src-TaskWindowContent-scroll-21778d69"};